<template>
	<div
		v-if="typeof data === 'object' && data.hasOwnProperty('container')"
		:class="[data.container.hasOwnProperty('classes') ? data.container.classes : '']"
		:style="setStyle(data.container).then(res => res)">
		<!-- Renders the columns -->
		<div v-for="(col,index) in data.container.columns" :key="index" :class="[col.container.classes,`content-block-${index+1}`]" :style="[Object.keys(col.container).indexOf('classes') !== -1 ? col.container.style : '']">

			<!-- For an array of content (for images and texts in a single block) -->
			<template v-if="Array.isArray(col.container.content)">
				<div v-for="(eachItemInACol,index) in col.container.content" :key="index"
					:class="eachItemInACol.hasOwnProperty('classes') ? eachItemInACol.classes : ''"
					:style="[eachItemInACol]">
					<!-- SVG: Genuine Leather -->
					<template
						v-if="typeof eachItemInACol['img'] === 'object' && eachItemInACol.img.src === 'logo-genuine-leather.svg'">
						<div class="genuine-leather" v-html="watermarkSVG"></div>
					</template>

					<!-- If an image -->
					<picture v-if="typeof eachItemInACol['img'] === 'object' && eachItemInACol.img.src != 'logo-genuine-leather.svg'" class="monogram relative">
						<img :src="require(`@/img/${eachItemInACol.img.src}`)"
							:alt="eachItemInACol.img.alt"
							:width="eachItemInACol.img.width"
							:height="eachItemInACol.img.height" />
					</picture>

					<!-- If copies -->
					<template v-if="typeof eachItemInACol['text'] === 'string'">
						<p v-html="eachItemInACol.text" :style="eachItemInACol.style"></p>
					</template>
				</div>
			</template>

			<!-- For an object of content (for only an image in a single block) -->
			<picture v-if="typeof col.container.content['img'] === 'object'">
				<img :src="require(`@/img/${col.container.content.img.src}`)"
					:alt="col.container.content.img.alt"
					:width="col.container.content.img.width" />
			</picture>

			<!-- For a string of content (for only a text in a single block) -->
			<div v-if="typeof col.container.content['text'] === 'string'"
				:class="Object.keys(col.container.content).indexOf('classes') !== -1 ? col.container.content.classes : ''"
				:style="[col.container.content]">
				<p class="text-sm sm:text-base md:text-lg" v-html="col.container.content.text"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	name: 'SwatchCopyProduct',

	props: {
		data: Object,
	},

	computed: {
		...mapGetters(['matchScreenSize']),
	},

	data: () => {
		return {
			watermarkSVG: '',
		};
	},

	methods: {
    ...mapActions(['setStyle']),
	},
	mounted() {
	},
}
</script>

<style lang="scss" scoped>
/**
 * All pages
 */
.logo-genuine-leather {
	width: 8rem;
}
/**
 * Brand > Force
 */
.xs,.sm {
	#brand-force {
		.swatch-copy-product {
			// Brand name
			.content-block-1 {
				left: 0%;
				background: bottom / cover no-repeat;
				min-height: 30rem;

				// Genuine Leather
				.logo-genuine-leather {
					width: 5rem;
					bottom: -50px;
				}
			}

			// Wooden belt
			.content-block-2 {
				background: bottom / contain no-repeat;
			}
		}
	}
}
.md,.lg,.xl {
	#brand-force {
		.swatch-copy-product {
			// Common
			.content-block-1,
			.content-block-2 {
				height: 30rem;
			}
			// Left
			.content-block-1 {
				background: right center / cover no-repeat;
				.brand-logo {
					right: -6rem;
				}
				// Genuine Leather
				.logo-genuine-leather {
					right: -2.5rem;
					.genuine-leather {
						width: 5rem;
						height: auto;
					}
				}
			}
			// Right
			.content-block-2 {
				background: right bottom / contain no-repeat;
			}
		}
	}
}
.lg,.xl {
	#brand-force {
		.swatch-copy-product {
			// Left
			.content-block-1 {
				// Genuine Leather
				.logo-genuine-leather {
					right: -3.5rem;
					.genuine-leather {
						width: 7rem;
					}
				}
			}
		}
	}
}

/**
 * Brand > Classic Milano
 */
.xs,.sm {
	#brand-classicmilano {
		.swatch-copy-product {
			// Brand name
			.content-block-1.brand {
				.brand-logo {
					right: 1rem;
				}
				// Genuine leather
				.logo-genuine-leather {
					width: 8rem;
					right: 3.5rem;
					bottom: -79px;
				}
			}
			// Belt
			.content-block-2 {
				background: center 80% / 62.5% no-repeat;
				.copy {
					top: 2.5rem;
				}
			}
		}
	}
}
.md,.lg,.xl {
	#brand-classicmilano {
		.swatch-copy-product {
			// Brand name
			.content-block-1.brand {
				.brand-logo {
					right: 1rem;
				}
				// Genuine leather
				.logo-genuine-leather {
					width: 5rem;
					top: 1.75rem;
					right: -2.5rem;
				}
			}

			// Belt
			.content-block-2 {
				background: center 75% / 62.5% no-repeat;
			}
		}
	}
}

/**
 * Brand > Cliff
 */
.xs,.sm {
	#brand-cliff {
		.swatch-copy-product {
			// Brand name
			.content-block-1.brand {
				background: right center / cover no-repeat;
				.brand-logo {
					right: 1rem;
					bottom: 1rem;
				}
				// Genuine leather
				.logo-genuine-leather {
					width: 5rem;
					bottom: -3rem;
					left: 4.75rem;
				}
			}
			// Wallet
			.content-block-2 {
				.copy-1 {
					top: 1rem;
				}
				.copy-2 {
					bottom: 1rem;
				}
			}
		}
	}
}
.md,.lg,.xl {
	#brand-cliff {
		.swatch-copy-product {
			// Brand name
			.content-block-1.brand {
				background: right center / cover no-repeat;
				.brand-logo {
					right: 3rem;
					bottom: 3rem;
					img {
						width: 13rem;
					}
				}
				// Genuine leather
				.logo-genuine-leather {
					width: 7rem;
					top: 3rem;
					right: -3.5rem;
				}
			}
			// Wallet
			.content-block-2 {
				.copy-1 {
					top: 1.5rem;
				}
				.copy-2 {
					bottom: 1.5rem;
				}
			}
		}
	}
}
</style>
